import React from 'react';
import styled from 'styled-components';
import { ActivityIndicator } from '../../atoms';

export type OverlayActivityIndicatorProps = {
    /**
     * Disables the background blur
     */
    disableBlur?: boolean;
};

const StyledLoadingIndicatorContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: grid;
    justify-items: center;
    align-items: center;
    ${(props: OverlayActivityIndicatorProps) =>
        props.disableBlur
            ? ''
            : `
    background-color: rgba(113,118,124,.25);
    backdrop-filter: blur(.25rem);
    `}
`;

export function OverlayActivityIndicator(
    props: OverlayActivityIndicatorProps,
): JSX.Element {
    const { disableBlur, ...rest } = props;
    return (
        <StyledLoadingIndicatorContainer disableBlur={disableBlur}>
            <ActivityIndicator size={'medium'} {...rest} />
        </StyledLoadingIndicatorContainer>
    );
}
